import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, center = false }) => (
  <FadeUp className={center ? "text-center" : ""}>
    <p className="mono text-xs uppercase tracking-[0.2em] text-[#E9C766] sm:text-sm">{eyebrow}</p>
    <h2 className="font-display mt-4 text-xl font-bold tracking-tight text-white sm:text-2xl lg:text-3xl">
      {title}
    </h2>
    {sub && (
      <p className={`mt-4 max-w-2xl text-base leading-relaxed text-[#A1A1AA] sm:text-lg ${center ? "mx-auto" : ""}`}>
        {sub}
      </p>
    )}
  </FadeUp>
);
